import {ArrayUtils as NewArrayUtils} from '@colonist/utils'

export namespace ArrayUtils {

    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */
    export function shuffle<T>(array: T[]): T[] {
        return NewArrayUtils.shuffle(array)
    }

    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */
    export function randomElementFromArray<T>(array: T[]): T {
        return NewArrayUtils.randomElementFromArray(array)
    }

    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */
    export function removeElementFromArray<T>(array: T[], element: T): boolean {
        return NewArrayUtils.removeElementFromArray(array, element)
    }

    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */
    export function countOccurenceOfValueInArray<T>(array: T[], value: T): number {
        return NewArrayUtils.countOccurenceOfValueInArray(array, value)
    }

    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */
    export function elementInArray<T>(array: T[], element: T): boolean {
        return NewArrayUtils.elementInArray(array, element)
    }

}
